const BaseUrl = "https://theapplified.com/galaxychain/api/v1/";
export const ACCEPT_HEADER = "application/x.galaxychain.v1+json";

export const contactus_url = BaseUrl + "contact-us";
